module.exports = __webpack_public_path__ + "static/media/Amortizacion-Cobro.0e5b5586.png";